const MAX_FRAME_INDEX = 900
const MAX_FRAME_COUNT = MAX_FRAME_INDEX + 1
export default {
  MAX_FRAME_COUNT,
  MAX_FRAME_INDEX
}
